import { render } from "./EconActivitiesCard.vue?vue&type=template&id=260bedf0&scoped=true"
import script from "./EconActivitiesCard.vue?vue&type=script&lang=js"
export * from "./EconActivitiesCard.vue?vue&type=script&lang=js"

import "./EconActivitiesCard.vue?vue&type=style&index=0&id=260bedf0&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260bedf0"]])

export default __exports__